import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['counter'];

  static values = { total: Number, format: String, selector: String };

  #field;
  #onInput;

  connect() {
    this.#field = this.selectorValue ? null : this.element.querySelector('input, textarea');
    if (this.#field) {
      this.#onInput = () => this.refresh();
      this.#field.addEventListener('input', this.#onInput);
      this.#field.addEventListener('change', this.#onInput);
    }
    this.refresh();
  }

  disconnect() {
    if (this.#field && this.#onInput) {
      this.#field.removeEventListener('input', this.#onInput);
      this.#field.removeEventListener('change', this.#onInput);
    }
  }

  refresh() {
    this.#render(this.#count());
  }

  update({ detail: { current, total } }) {
    if (Number.isFinite(total)) {
      this.totalValue = total;
    }
    this.#render(current);
  }

  // With no field and no selector the count comes from `update` events, so there
  // is nothing to count here and whatever the server rendered stays put.
  #count() {
    if (this.#field) {
      return this.#field.value.length;
    }
    if (this.selectorValue) {
      return this.element.querySelectorAll(this.selectorValue).length;
    }
    return undefined;
  }

  #render(current) {
    if (!Number.isFinite(current)) {
      return;
    }

    this.counterTarget.textContent = this.formatValue
      .replace('%{current}', current)
      .replace('%{total}', this.totalValue);
    this.dispatch('counted', { detail: { current, total: this.totalValue } });
  }
}
